import { __ } from '@wordpress/i18n'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  ForgetPasswordForm,
  ResetPasswordForm,
} from '../../features/authentication'
import useAuth from '../../hooks/useAuth'

function LostPassword() {
  const { isLoggedIn } = useAuth()
  const navigate = useNavigate()

  const urlParams = new URLSearchParams(window.location.search)
  const showResetForm = urlParams.get('show-reset-form')

  useEffect(() => {
    document.title = showResetForm
      ? __('Reset Password', 'asavagroup')
      : __('Lost Password', 'asavagroup')
    if (isLoggedIn) {
      navigate('/my-account')
    }
  }, [isLoggedIn, navigate, showResetForm])

  if (showResetForm) {
    return (
      <div className="py-20">
        <div className="mx-auto max-w-screen-sm">
          <ResetPasswordForm />
        </div>
      </div>
    )
  }

  return (
    <div className="py-20">
      <div className="mx-auto max-w-screen-sm">
        <ForgetPasswordForm />
      </div>
    </div>
  )
}

export default LostPassword
